import React from "react";
import { EcpCustomerInteractionsTable } from "../entities/ecp/ecp-customerInteraction-entity";

export function EcpCustomerInteractionsPage(props) {
  return <EcpCustomerInteractionsTable {...props} />;
}
